import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/Register.css";
import { Country, State } from "country-state-city";
import { connectSocket } from "../socket";
import { toast } from "react-toastify";

export default function CompleteRegistration() {
  const qs = new URLSearchParams(useLocation().search);
  const email = qs.get("email");
  const name = qs.get("name");
  const category = qs.get("category");

  const [formData, setFormData] = useState({
    phone: "",
    country: "",
    state: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    const { phone, country, state, password, confirmPassword } = formData;
    if (!phone || !country || !state || !password || !confirmPassword)
      return toast.error("All fields are required.");
    if (password !== confirmPassword)
      return toast.error("Passwords do not match.");

    const body = { email, name, phone, country, state, password, category, role: category };
    setLoading(true);

    try {
      const res = await fetch("https://globisun-app.onrender.com/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      setLoading(false);

      if (!res.ok) return toast.error(data.msg || "Registration failed.");

      toast.success("✅ Registration successful!");

      // Connect socket for the new user
      if (data.user && data.user._id) {
        const socket = connectSocket(data.user._id);
        socket.on("newNotification", ({ type, message }) => {
          toast.info(`📢 ${type}: ${message}`);
        });
      }

      navigate("/login");
    } catch (err) {
      console.error(err);
      toast.error("❌ Error completing registration");
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box">
        <h2>Complete Registration</h2>
        <p>Welcome, <strong>{name}</strong></p>

        <input
          name="phone"
          type="tel"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
        />

        <select name="country" value={formData.country} onChange={handleChange}>
          <option value="">Select Country</option>
          {Country.getAllCountries().map(c => (
            <option key={c.isoCode} value={c.isoCode}>{c.name}</option>
          ))}
        </select>

        <select
          name="state"
          value={formData.state}
          onChange={handleChange}
          disabled={!formData.country}
        >
          <option value="">Select State</option>
          {State.getStatesOfCountry(formData.country).map(s => (
            <option key={s.isoCode} value={s.isoCode}>{s.name}</option>
          ))}
        </select>

        <input
          name="password"
          type="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
        />
        <input
          name="confirmPassword"
          type="password"
          placeholder="Confirm Password"
          value={formData.confirmPassword}
          onChange={handleChange}
        />

        <button onClick={handleRegister} disabled={loading}>
          {loading ? "Registering..." : "Complete Registration"}
        </button>
      </div>
    </div>
  );
}
